import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PlaybackState {
  isPlaying: boolean;
  currentTime: number;
  speed: number;
}

export interface VehiclePosition {
  vehicleId: string;
  lat: number;
  lng: number;
  speed: number;
  heading?: number;
}

@Injectable({
  providedIn: 'root'
})
export class RouteReplayMapControlService {
  private vehiclePositionsSubject = new BehaviorSubject<Map<string, VehiclePosition>>(new Map());
  vehiclePositions$ = this.vehiclePositionsSubject.asObservable();

  private playbackStateSubject = new BehaviorSubject<PlaybackState>({
    isPlaying: false,
    currentTime: 0,
    speed: 1
  });
  playbackState$ = this.playbackStateSubject.asObservable();

  private currentTimeSubject = new BehaviorSubject<number>(0);
  currentTime$ = this.currentTimeSubject.asObservable();

  constructor() {}

  updateVehiclePosition(vehicleId: string, position: VehiclePosition): void {
    const positions = this.vehiclePositionsSubject.value;
    positions.set(vehicleId, position);
    this.vehiclePositionsSubject.next(new Map(positions));
  }

  updatePlaybackState(state: Partial<PlaybackState>): void {
    const currentState = this.playbackStateSubject.value;
    this.playbackStateSubject.next({ ...currentState, ...state });
  }

  updateCurrentTime(time: number): void {
    this.currentTimeSubject.next(time);
  }

  clearVehiclePositions(): void {
    this.vehiclePositionsSubject.next(new Map());
  }
}
